import { render, staticRenderFns } from "./ClientBlockMedialpha.vue?vue&type=template&id=43acfac3&"
import script from "./ClientBlockMedialpha.vue?vue&type=script&lang=js&"
export * from "./ClientBlockMedialpha.vue?vue&type=script&lang=js&"
import style0 from "./ClientBlockMedialpha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports